var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { CaseApplyOperateService } from "~/services/domain-service/case-apply-operate.service";
import { UploadFileService } from "~/services/common-service/upload-file.service";
import { Emit, Prop } from "vue-property-decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { UserService } from "~/services/manage-service/user.service";
import DataBox from "~/components/common/data-box.vue";
var SupplementManagePending = /** @class */ (function (_super) {
    __extends(SupplementManagePending, _super);
    function SupplementManagePending() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.supplementselectionList = [];
        _this.nowNode = null;
        _this.caseList = []; // 案件数组
        _this.supplementDataSet = [];
        _this.SearchModel = {
            applyType: "SUPPLEMENT_APPLY",
            approvalStatus: "WAIT_APPROVAL"
        };
        _this.loading = {
            state: false
        };
        return _this;
    }
    SupplementManagePending.prototype.refreshList = function () { };
    SupplementManagePending.prototype.approvedMeth = function (rowData) { };
    /**
     * 选择点变化
     */
    SupplementManagePending.prototype.getCheckedNodes = function (item) {
        this.nowNode = item;
        this.refreshData();
    };
    /**
     * 刷新
     */
    SupplementManagePending.prototype.refresh = function (caseList) {
        this.caseList = caseList;
    };
    /**
     * 刷新用户列表
     */
    SupplementManagePending.prototype.refreshData = function () {
        var _this = this;
        this.loading.state = true;
        this.SearchModel = Object.assign(this.SearchModel, this.supplementModel);
        this.caseApplyOperateService
            .caseApprovalSearch(this.SearchModel, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) {
            _this.supplementDataSet = data;
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    SupplementManagePending.prototype.downloadFile = function (row) {
        var _this = this;
        this.uploadFileService
            .getFileStreamById(row.fileId, row.fileName)
            .subscribe(function () { return _this.$message.success("下载成功"); });
    };
    //审批操作
    SupplementManagePending.prototype.approvedSupplementMeth = function (scope) {
        var rowData = scope.row;
        this.approvedMeth(rowData);
    };
    __decorate([
        Dependencies(PageService)
    ], SupplementManagePending.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], SupplementManagePending.prototype, "sortService", void 0);
    __decorate([
        Dependencies(UserService)
    ], SupplementManagePending.prototype, "userService", void 0);
    __decorate([
        Dependencies(UploadFileService)
    ], SupplementManagePending.prototype, "uploadFileService", void 0);
    __decorate([
        Dependencies(CaseApplyOperateService)
    ], SupplementManagePending.prototype, "caseApplyOperateService", void 0);
    __decorate([
        Emit("refreshList")
    ], SupplementManagePending.prototype, "refreshList", null);
    __decorate([
        Emit("approvedMeth")
    ], SupplementManagePending.prototype, "approvedMeth", null);
    __decorate([
        Prop()
    ], SupplementManagePending.prototype, "supplementModel", void 0);
    SupplementManagePending = __decorate([
        Component({
            components: {
                DataBox: DataBox
            }
        })
    ], SupplementManagePending);
    return SupplementManagePending;
}(Vue));
export default SupplementManagePending;
